import { all } from 'redux-saga/effects';

import watchGetTranslationFile from './translationFile';
import watchGetDocumentData from './document';
import watchFetchDocumentData from './documentMeta';
import watchFetchAssessment from './assessment';
import watchFetchAssessmentPage from './assessmentPage';
import watchFetchAssessmentSummary from './assessmentSummary';

export default function* rootSaga() {
  yield all([
    watchGetTranslationFile(),
    watchGetDocumentData(),
    watchFetchDocumentData(),
    watchFetchAssessment(),
    watchFetchAssessmentPage(),
    watchFetchAssessmentSummary(),
  ]);
}
